import React, { useState, useEffect } from 'react';
import './App.css';
import TextMasker from './components/TextMasker';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Sensitive Data Masker</h1>
        <p>Mask your sensitive data before sharing with AI services</p>
      </header>
      <main>
        <TextMasker />
      </main>
      <footer>
        <p>All processing happens in your browser. No data is sent to any server.</p>
      </footer>
    </div>
  );
}

export default App;
